import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component';
import { FormService } from 'app/services/form.service';
import { DocumentConstants } from 'app/constants/document.constants';
import { AttachmentModel } from 'app/models/attachment.model';

@Component({
  selector: 'app-statement-of-adoption',
  templateUrl: './statement-of-adoption.component.html',
  styleUrls: ['./statement-of-adoption.component.scss']
})
export class StatementOfAdoptionComponent {
  readonly dialog = inject(MatDialog);

  constructor(private formService: FormService) {}
  
  public openDialog(): void {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
      data: { fileName: DocumentConstants.STATEMENT_OF_ADOPTION }
    });
    dialogRef.afterClosed().subscribe();
  }

  get hasStatementOfAdoptionFile(): boolean {
    return this.formService.doesCurrentFormHaveAttachmentForSection(DocumentConstants.STATEMENT_OF_ADOPTION);
  }

  get attachments(): AttachmentModel[] {
    return this.formService.allAttachmentsForSection(DocumentConstants.STATEMENT_OF_ADOPTION);
  }

  get formType(): string {
    return this.formService.getCurrentUsanFormType();
  }

  get isFormDType(): boolean {
    return 'FormD' === this.formType;
  }

}
